import { render, staticRenderFns } from "./QxUpload.vue?vue&type=template&id=2ec7fa7e&scoped=true&"
import script from "./QxUpload.vue?vue&type=script&lang=js&"
export * from "./QxUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7fa7e",
  null
  
)

export default component.exports